import { useEffect, useRef } from "react";

// Allows us to look into the previous value of a state when it changes
export default function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
